import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Flame, CheckCircle2 } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="comprar" className="py-14 sm:py-18 px-4 sm:px-6 lg:px-8 bg-deco-bg relative overflow-hidden scroll-mt-10" data-id="element-199">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-deco-terra/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-200"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-deco-sage/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-201"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-202">
        <div className="text-center mb-10" data-id="element-203">
          <div className="inline-flex items-center gap-2 bg-deco-terra/10 text-deco-terra px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-8 border border-deco-terra/20" data-id="element-204">
            <Flame size={16} data-id="element-205" />
            Oferta por tiempo limitado
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6 text-deco-text" data-id="element-206">
            Elegí el kit ideal para empezar a crear
          </h2>

          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-207">
            <span className="text-deco-text/80 font-semibold text-sm sm:text-base uppercase tracking-wider" data-id="element-208">
              Esta oferta termina en
            </span>
            <div className="flex items-center gap-1.5 font-mono text-lg sm:text-xl font-bold" data-id="element-209">
              <span className="bg-deco-terra text-white rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-210">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-deco-terra text-2xl font-bold" data-id="element-211">:</span>
              <motion.span key={`ps-${timeLeft.seconds}`} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.15
            }} className="bg-deco-terra text-white rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-212">
                {pad(timeLeft.seconds)}
              </motion.span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-213">
          {/* Kit Inicial Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-[2rem] p-8 shadow-lg border border-deco-warm flex flex-col justify-between text-center" data-id="element-214">
            <div data-id="element-215">
              <h3 className="text-2xl font-serif font-bold text-deco-text mb-2" data-id="element-216">
                Kit Inicial
              </h3>
              <p className="text-deco-text/80 mb-6 text-sm sm:text-base" data-id="element-217">
                Para aprender desde cero y crear tus primeras flores simples.
              </p>
              <p className="text-4xl font-bold text-deco-text mb-8" data-id="element-218">
                $19.990{' '}
                <span className="text-lg text-deco-taupe font-normal" data-id="element-219">ARS</span>
              </p>
            </div>

            <div className="space-y-3 mb-8" data-id="element-220">
              {['Guía de introducción', '10 flores simples paso a paso', '+50 ideas de inspiración', 'Videos tutoriales de apoyo'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-221">
                  <CheckCircle2 size={18} className="text-deco-terra shrink-0 mt-0.5" data-id="element-222" />
                  <span className="text-deco-text/90 text-sm font-medium" data-id="element-223">
                    {item}
                  </span>
                </div>)}
            </div>

            <a href="https://pago.atlasdigitalhub.com/cart/42966895067234:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 rounded-full bg-deco-sage text-white font-bold text-center hover:bg-deco-sage-dark transition-colors shadow-md uppercase tracking-wider text-sm" data-id="element-224">
              QUIERO EL KIT INICIAL
            </a>
          </motion.div>

          {/* Mega Kit Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-deco-terra text-white rounded-[2rem] p-8 shadow-2xl border border-deco-terra relative flex flex-col justify-between text-center transform md:-translate-y-4" data-id="element-225">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-deco-terra px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider shadow-sm whitespace-nowrap" data-id="element-226">
              Más elegido / Más completo
            </div>

            <div data-id="element-227">
              <h3 className="text-2xl font-serif font-bold mb-2 mt-2" data-id="element-228">
                Mega Kit
              </h3>
              <p className="text-white/90 mb-6 text-sm sm:text-base" data-id="element-229">
                Para aprender más modelos, armar ramos y vender tus creaciones.
              </p>
              <p className="text-4xl font-bold mb-8" data-id="element-230">
                $29.990{' '}
                <span className="text-lg text-white/80 font-normal" data-id="element-231">ARS</span>
              </p>
            </div>

            <div className="space-y-3 mb-8" data-id="element-232">
              {['Todo lo del Kit Inicial', '+20 modelos de flores', 'Armado de ramos', '+100 ideas de inspiración', 'Guía de Emprendimiento', 'Videos tutoriales de apoyo'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-233">
                  <CheckCircle2 size={18} className="text-white shrink-0 mt-0.5" data-id="element-234" />
                  <span className="text-white/90 text-sm font-medium" data-id="element-235">
                    {item}
                  </span>
                </div>)}
            </div>

            <motion.a href="https://pago.atlasdigitalhub.com/cart/42966895100002:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0px 0px 0px 0px rgba(255,255,255,0.4)', '0px 0px 0px 15px rgba(255,255,255,0)', '0px 0px 0px 0px rgba(255,255,255,0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop'
          }} className="block w-full py-4 px-6 rounded-full bg-white text-deco-terra font-bold text-center hover:bg-white/90 transition-colors shadow-xl uppercase tracking-wider text-sm" data-id="element-236">
              QUIERO EL MEGA KIT
            </motion.a>
          </motion.div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-10 text-xs sm:text-sm text-deco-taupe font-medium" data-id="element-237">
          <ShieldCheck size={16} data-id="element-238" />
          <span data-id="element-239">Acceso inmediato · Producto digital · Pago seguro</span>
        </div>
      </div>
    </section>;
}